import domReady from '@wordpress/dom-ready';

const SELECTOR_CONTAINER =
  '.page-template-template-events .findstrResultsContainer';
const ITEM_SELECTOR = '.event-item';
const GROUP_CLASS = 'event-group';

const formatMonthYear = (my) => {
  const [m, y] = (my || '').split('-');
  const date = new Date(Number(y), Number(m) - 1, 1);
  return date.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
};

const parseMy = (my) => {
  const [m, y] = (my || '').split('-');
  const month = Number(m);
  const year = Number(y);
  if (
    !Number.isInteger(month) ||
    !Number.isInteger(year) ||
    month < 1 ||
    month > 12
  )
    return null;
  return { year, month };
};

const buildGroups = (eventsList) => {
  const eventItems = Array.from(eventsList.querySelectorAll(ITEM_SELECTOR));

  if (!eventItems.length) {
    eventsList.innerHTML = '';
    return;
  }

  const groups = new Map();

  for (const item of eventItems) {
    const my = item.dataset.my;
    const parsed = parseMy(my);
    if (!parsed) continue;
    if (!groups.has(my)) groups.set(my, []);
    groups.get(my).push(item);
  }

  const sortedKeys = Array.from(groups.keys()).sort((a, b) => {
    const A = parseMy(a);
    const B = parseMy(b);
    if (A.year !== B.year) return A.year - B.year;
    return A.month - B.month;
  });

  const frag = document.createDocumentFragment();

  for (const my of sortedKeys) {
    const group = document.createElement('div');
    group.className = GROUP_CLASS;
    group.dataset.my = my;

    const title = document.createElement('h2');
    title.textContent = formatMonthYear(my);
    group.appendChild(title);

    for (const item of groups.get(my)) {
      group.appendChild(item);
    }

    frag.appendChild(group);
  }

  eventsList.innerHTML = '';
  eventsList.appendChild(frag);
};

const setupObserver = (eventsList) => {
  let rafId = null;
  let isRebuilding = false;

  const observer = new MutationObserver((mutations) => {
    const relevant = mutations.some((m) => m.type === 'childList');
    if (!relevant || isRebuilding) return;
    if (rafId) cancelAnimationFrame(rafId);

    rafId = requestAnimationFrame(() => {
      rafId = null;
      isRebuilding = true;
      observer.disconnect();
      try {
        buildGroups(eventsList);
      } finally {
        observer.observe(eventsList, { childList: true, subtree: true });
        isRebuilding = false;
      }
    });
  });

  observer.observe(eventsList, { childList: true, subtree: true });
  buildGroups(eventsList);

  return () => {
    if (rafId) cancelAnimationFrame(rafId);
    observer.disconnect();
  };
};

const initEventsGrouper = () => {
  const eventsList = document.querySelector(SELECTOR_CONTAINER);
  if (!eventsList) return;

  const teardown = setupObserver(eventsList);

  const parent = eventsList.parentElement;
  if (parent) {
    const containerObserver = new MutationObserver(() => {
      const fresh = document.querySelector(SELECTOR_CONTAINER);
      if (fresh && fresh !== eventsList) {
        teardown?.();
        setupObserver(fresh);
      }
    });

    containerObserver.observe(parent, { childList: true });
  }
};

domReady(() => {
  initEventsGrouper();
});
